import { z } from 'zod';

/**
 * Money is a plain float64 in the project currency. Round only for display.
 * Amounts are magnitudes; direction is carried separately (in/out).
 */
export const MAX_AMOUNT = 1e12;

export const amountSchema = z.number().min(0).max(MAX_AMOUNT);

/** A signed money value, e.g. a starting cash balance that may be negative. */
export const signedMoneySchema = z.number().min(-MAX_AMOUNT).max(MAX_AMOUNT);

/** Annual rate as a fraction: 0.03 = 3 %/year. Bounded to keep the maths meaningful. */
export const annualRateSchema = z.number().min(-0.99).max(10);

/** A proportion such as a formula percentage: 0.2 = 20 %. */
export const fractionSchema = z.number().min(0).max(10);

export const currencySchema = z.string().regex(/^[A-Z]{3}$/, 'ISO 4217 code, e.g. EUR');
